
import BeamDefault from "../../../assets/filled/BeamDefault.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BeamDefaultIcon({ className, dataTestid = "BeamDefaultIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BeamDefault data-testid={dataTestid} className={classes} {...rest} />
  );
}
